import { useNavigate, useParams } from 'react-router-dom';
import { useGetThemeQuery } from 'src/api/themes';
import { useGlobalModals } from 'src/contexts/global-modals';

export const useThemeDetails = () => {
  const { id } = useParams();
  const themeId = Number(id);
  const navigate = useNavigate();

  const { openDeleteThemeModal } = useGlobalModals();

  const handleDelete = () => {
    openDeleteThemeModal(themeId);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const { data, isPending, isError } = useGetThemeQuery(themeId);

  return {
    theme: data,
    isPending,
    isError,
    handleDelete,
    handleCancel,
  };
};
